



































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import LeftNavigationComponent from "./LeftNavigation.vue";
import TopNavigationComponent from "./TopNavigation.vue";
import NavigationButtons from "./NavigationButtons.vue";
import { TechnicalApplication, Workspace } from "@/entities";
import { Utilities as __utils } from "@/shared/utilities.ts";
import "vuetify/dist/vuetify.min.css";
import "@pan-gms/vuetify-jsonschema-form/dist/main.css";
import { http as _http } from '@/shared/https';
import { AppConstants as _app } from '@/shared/app.constants';
import { Locales } from "@/i18n/locales";

const namespace: string = "application";

@Component({
  components: {
    TopNavigationComponent,
    VJsonschemaForm,
    LeftNavigationComponent,
    NavigationButtons
  }
})
export default class TechnicalApplicationComponent extends Vue {  
  @Action("updateProjectTitle", { namespace }) updateTitle: any;
  @Action("uploadDocument", { namespace }) uploadDocument: any;
  @Action("saveTechnicalApplication", { namespace }) saveTechnicalApplication: any;
  @Getter("technicalApplication", { namespace }) application: TechnicalApplication;
  @Getter("techAppKey", { namespace }) subKey: any;
  @Getter("rootTemplate", { namespace }) schema: any;
  @State(namespace) app!: Workspace;
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Prop() isDirty!: boolean;

  /** declare variables */
  formValid: boolean = false;
  showSideBar = true;
  renderComponent: boolean = true;
  data: any = {};
  schemaformKey: number = 0;
  snackbar:boolean=false;
  snackBarColor:string="red";
  message:any;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;


  get options() {
    return {
      disableAll: (this.readOnly && this.readOnly === true) ? true : false,
      "uploadAction": this.uploadDocument,
      "removeAction": this.$services.document.removeDocument,
      "downloadAction": this.$services.document.download,
      "locale": this.defaultLocale,
      "ApplicationId": this.app.application.ApplicationId,
      "httpLib": _http,
      "baseURI": process.env.VUE_APP_API_Base_URL,
      "currency": this.app.application.BudgetCurrency,
      "startDate": this.datum.projectStartDate,
      "endDate":  this.datum.projectEndDate,
      "fileSizeLimit": this.appSettings.MaxFileSizeLimit,
      "selectItems":{"country":this.app.application.Countries, "region":this.app.application.Regions},
    }
  }

  /** mounted fn */
  mounted() {
    var selectedSubMenu = '';

    // get the default tab
    if(this.subProps.length > 0)       
      var selectedSubMenu = this.subProps[0];

    // update the default tab, if hash value exists
    if(this.$route.params.section === 'technicalApplication') {
        
        if(this.$route.hash)
          selectedSubMenu = this.$route.hash.substr(1);
    }

    // update the state
    if(selectedSubMenu)
      this.$emit('submenuChanged', { key: 'technicalApplication', subMenu: selectedSubMenu });    
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

  /**  update the sub menu on left panel selection */
  subMenuChanged(selectedMenu, key) {
    this.$emit('submenuChanged', { key: 'technicalApplication', subMenu: key }); 
  }

  /** error event */
  showError(err) {
    window.alert(err);
  }

  /** change event */
  showChange(e) {
    this.$emit("input", true);
  }

  /** get summary of the technical application */
  summary() {
    this.$services.summary.getTechnicalApplicationSummary(
      this.application.templates,
      this.datum
    );
  }

  /** input event */
  showInput(e) {
    this.$emit("input", true);
    // console.log('"input" event', e)
  }

  /** get all subtabs */
  get subProps(): Array<string> {
    if (this.application.templates && this.application.templates.properties) {
      return Object.keys(this.application.templates.properties);
    } else {
      return [];
    }
  }

  /** get child schema properties to populate the left panel*/
  get subSchema(): any {
   if (this.application.templates && this.application.templates.properties && this.subKey) {
      var schema = this.application.templates.properties[
        this.subKey
      ];
      schema['x-virtual'] = false;
      return schema;
    } else {
      return {};
    }
  }

  /** application data */
  get datum(): any {
    return this.appData;
  }

  /** watch state and update the variable */
  @Watch("appData")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }

  @Watch("datum.projectTitle")
  onTitleChanged(value: any, oldValue: any) {
    if(!this.readOnly) {
      this.updateTitle(value);
    }
  }

  @Watch("subKey")
  onSubKeyChanged(value: any) {
    this.schemaformKey += 1;

    // reset scroll bar to top
    if(this.$refs.wrapper) {
      this.$refs.wrapper["scrollTop"] = 0;
    }
  }

  @Watch("datum.projectStartDate")
  onStartDateChanged(value: any, oldValue: any) {
    if(this.datum.projectStartDate && this.datum.projectEndDate && this.app.application.Duration)
    {
      //let monthDiff=__utils.addMonths(this.datum.projectStartDate, this.app.application.Duration)
      if((__utils.monthDiff(this.datum.projectStartDate, this.datum.projectEndDate)>this.app.application.Duration))
      {
          this.message=this.$t(`Project duration should not exceed ${this.app.application.Duration} ${this.$t('months')}`)
          this.snackbar=true;
      }
      /*if(__utils.diffDays(monthDiff,this.datum.projectEndDate)<0)
      {
        this.message=this.$t(`Project duration should not exceed ${this.app.application.Duration} ${this.$t('months')}`)
        this.snackbar=true;
      }*/
    }
    if(this.datum.projectStartDate && this.datum.projectEndDate) {
      this.datum.projectDuration = `${__utils.monthDiff(this.datum.projectStartDate, this.datum.projectEndDate)} ${this.$t('months')}`;
    }
    else if(value === null) {
      this.datum.projectDuration = ""
    }
  }

  @Watch("datum.projectEndDate")
  onendDateChanged(value: any, oldValue: any) {
    if(this.datum.projectStartDate && this.datum.projectEndDate && this.app.application.Duration)
    {
      //let monthDiff=__utils.addMonths(this.datum.projectStartDate, this.app.application.Duration)
      if((__utils.monthDiff(this.datum.projectStartDate, this.datum.projectEndDate)>this.app.application.Duration))
      {
          this.message=this.$t(`Project duration should not exceed ${this.app.application.Duration} ${this.$t('months')}`)
          this.snackbar=true;
      }
      /*if(__utils.diffDays(monthDiff,this.datum.projectEndDate)<0)
      {
        this.message=this.$t(`Project duration should not exceed ${this.app.application.Duration} ${this.$t('months')}`)
        this.snackbar=true;
      }*/
    }
    if(this.datum.projectStartDate && this.datum.projectEndDate) {
      this.datum.projectDuration = `${__utils.monthDiff(this.datum.projectStartDate, this.datum.projectEndDate)} ${this.$t('months')}`;
    }
    else if(value === null) {
      this.datum.projectDuration = ""
    }
  }

  @Watch("datum.sameAsAuthSignatury")
  sameAsAuthSignatury(value: any) {
    if(this.readOnly)
      return;

    if (value) {
      this.datum["projectLeadName"] = this.datum["authSignaturyName"];
      this.datum["projectLeadJobTitle"] = this.datum["authSignaturyJobTitle"];
      this.datum["ProjectLeadTelephone"] = this.datum["authSignaturyTelephone"];
      this.datum["projectLeadEmail"] = this.datum["authSignaturyEmail"];
    } else {
      this.datum["projectLeadName"] = undefined;
      this.datum["projectLeadJobTitle"] = undefined;
      this.datum["ProjectLeadTelephone"] = undefined;
      this.datum["projectLeadEmail"] = undefined;
    }
  }

}
